import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const PageWrapper = ({ children, sx = {} }) => {
  const theme = useTheme()
  const isMDUp = useMediaQuery(theme.breakpoints.up('md'))
  const isLGUp = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Box
      sx={{
        marginLeft: isMDUp ? '300px' : '0px',
      }}
    >
      <Box
        minHeight="calc(100% - 56px)"
        px={2}
        pt={2}
        margin="0 auto"
        sx={{
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: `${1024 - 300}px}`,
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default PageWrapper
